import { render } from "./admin-company-department.vue?vue&type=template&id=5214872c"
import script from "./admin-company-department.vue?vue&type=script&lang=js"
export * from "./admin-company-department.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-company-department.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5214872c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5214872c', __exports__)) {
    api.reload('5214872c', __exports__)
  }
  
  module.hot.accept("./admin-company-department.vue?vue&type=template&id=5214872c", () => {
    api.rerender('5214872c', render)
  })

}


export default __exports__